import PropTypes from 'prop-types'

import MotorMarkdownWrapper from '@adv-mt/mt-markdown-wrapper/lib/ReservationTc'

const TermsContent = ({documentName}) => {
  return (
    <div className="mt-DrawerReservationInitialization-termsContent">
      <MotorMarkdownWrapper documentName={documentName} />
    </div>
  )
}

TermsContent.displayName = 'TermsContent'

TermsContent.propTypes = {
  documentName: PropTypes.string
}

export default TermsContent
